export default __webpack_public_path__ + "static/media/inr_violet.7fc859c9.svg";